/* Cecilia Dream · Size Guide com localizador de altura (so paginas de produto).
   Le a tabela que o bloco "Size Guide" do modelo ja escreve (cm e in) e monta o guia novo por cima.
   Se o produto tem uma coluna com "height" no nome (ex.: "Her height"), aparece o campo
   "How tall is she?", que sugere o tamanho e o botao "Choose ..." que marca o tamanho na pagina.
   Sem essa coluna, a tabela aparece no mesmo estilo, sem o localizador. */
(function () {
  'use strict';

  var HELP = 'hello@ceciliadream.com';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function txt(el) { return el ? (el.textContent || '').trim() : ''; }
  function fmt(n) { return String(Math.round(n * 10) / 10); }

  function readTable(box) {
    var t = box && box.querySelector('table');
    if (!t) return null;
    return {
      cols: [].map.call(t.querySelectorAll('thead th'), txt),
      rows: [].map.call(t.querySelectorAll('tbody tr'), function (tr) { return [].map.call(tr.children, txt); })
    };
  }

  function parseRange(cell) {
    var n = String(cell || '').replace(/,/g, '.').match(/\d+(?:\.\d+)?/g);
    return n && n.length >= 2 ? [parseFloat(n[0]), parseFloat(n[1])] : null;
  }

  function findVariant(age) {
    var a = age.toLowerCase(), i, list;
    list = document.querySelectorAll('variant-radios input[type="radio"], .product-form__input input[type="radio"]');
    for (i = 0; i < list.length; i++) {
      if ((list[i].value || '').toLowerCase().indexOf(a) === 0) return { kind: 'radio', el: list[i] };
    }
    list = document.querySelectorAll('variant-selects select option, .product-form__input select option');
    for (i = 0; i < list.length; i++) {
      if ((list[i].value || '').toLowerCase().indexOf(a) === 0) return { kind: 'option', el: list[i] };
    }
    return null;
  }

  function enhance(wrap) {
    if (wrap.getAttribute('data-cd2')) return;
    var dlg = wrap.querySelector('dialog'), inner = wrap.querySelector('.cdsg-in');
    var cm = readTable(wrap.querySelector('.cdsg-scroll[data-unit="cm"]'));
    var inch = readTable(wrap.querySelector('.cdsg-scroll[data-unit="in"]'));
    if (!dlg || !inner || !cm || !cm.rows.length) return;
    wrap.setAttribute('data-cd2', '1');

    var oldStyle = wrap.querySelector('style');
    if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);

    var title = txt(inner.querySelector('h3')), intro = txt(inner.querySelector('.cdsg-intro')), tip = txt(inner.querySelector('.cdsg-tip'));
    var img = inner.querySelector('.cdsg-img'), closeForm = inner.querySelector('form');

    var hIdx = -1, ranges = [];
    cm.cols.forEach(function (c, i) { if (hIdx < 0 && i > 0 && /height/i.test(c)) hIdx = i; });
    if (hIdx > 0) {
      ranges = cm.rows.map(function (r) { return parseRange(r[hIdx]); });
      if (ranges.some(function (x) { return !x; })) hIdx = -1;
    }
    var canFind = hIdx > 0 && ranges.length > 0;
    var hasIn = !!(inch && inch.rows.length === cm.rows.length);
    var uid = 'cd2-' + Math.random().toString(36).slice(2, 8);
    var unit = 'cm', hit = -1;

    var tipHTML = '';
    if (tip) {
      var cut = tip.search(/[.!?](\s|$)/);
      tipHTML = cut > 0 ? '<b>' + esc(tip.slice(0, cut + 1)) + '</b>' + esc(tip.slice(cut + 1)) : esc(tip);
    }
    var titleHTML = canFind ? 'Find her <em>size</em>' : esc(title || 'Size guide');
    var introText = intro || (canFind ? "Height tells us more than age. Tell us how tall she is and we'll point to her size." : '');

    var unitsHTML = hasIn
      ? '<div class="cd2-units" role="group" aria-label="Units"><button type="button" class="on" data-u="cm" aria-pressed="true">cm</button><button type="button" data-u="in" aria-pressed="false">in</button></div>'
      : '';

    inner.innerHTML =
      '<div class="cd2">' +
      '<p class="cd2-eyebrow">Size guide</p>' +
      '<p class="cd2-title" role="heading" aria-level="3">' + titleHTML + '</p>' +
      (introText ? '<p class="cd2-intro">' + esc(introText).replace(/^([^.!?]+[.!?])/, '<b>$1</b>') + '</p>' : '') +
      (canFind
        ? '<div class="cd2-finder"><div class="cd2-row"><label for="' + uid + '">How tall is she?</label>' +
          '<input id="' + uid + '" type="number" inputmode="decimal" min="0" step="0.5" placeholder="e.g. 112">' + unitsHTML + '</div>' +
          '<p class="cd2-result" aria-live="polite"></p></div>'
        : unitsHTML) +
      '<p class="cd2-cap"></p><div class="cd2-slot"></div>' +
      '<div class="cd2-foot">' +
      (tipHTML ? '<div class="cd2-note"><p>' + tipHTML + '</p></div>' : '') +
      (canFind ? '<p class="cd2-more"><b>Not sure?</b> Choose the larger size. If it’s not right, tell us within 30 days and we’ll make it right.</p>' : '') +
      '</div></div>';

    var root = inner.querySelector('.cd2');
    if (closeForm) root.insertBefore(closeForm, root.firstChild);
    if (img) root.appendChild(img);

    var slot = root.querySelector('.cd2-slot'), cap = root.querySelector('.cd2-cap');
    var input = root.querySelector('input'), res = root.querySelector('.cd2-result');

    function draw() {
      var data = unit === 'in' && hasIn ? inch : cm;
      var head = data.cols.map(function (c) { return '<th scope="col">' + esc(c) + '</th>'; }).join('');
      var body = data.rows.map(function (r, i) {
        return '<tr' + (hit === i ? ' class="hit"' : '') + '>' + r.map(function (c, j) {
          if (j === 0) return '<th scope="row">' + esc(c) + '</th>';
          return '<td>' + (j === hIdx ? '<span class="hv">' + esc(c) + '</span>' : esc(c)) + '</td>';
        }).join('') + '</tr>';
      }).join('');
      slot.innerHTML = '<div class="cd2-scroll"><table class="cd2-t"><thead><tr>' + head + '</tr></thead><tbody>' + body + '</tbody></table></div>';
      cap.textContent = unit === 'in' && hasIn ? 'All measurements in inches (in).' : 'All measurements in centimetres (cm).';
    }

    function find() {
      if (!canFind) return;
      hit = -1;
      var v = parseFloat(input.value);
      if (!v || v <= 0) { res.innerHTML = "Type her height and we'll find her size."; return; }
      var h = unit === 'in' ? v * 2.54 : v;
      var min = ranges[0][0], max = ranges[ranges.length - 1][1];
      var help = ' Write to us at ' + HELP + " and we'll help you choose.";
      if (h < min) { res.innerHTML = "She's a little smaller than our smallest size (" + fmt(min) + ' cm / ' + fmt(min / 2.54) + ' in).' + help; return; }
      if (h > max) { res.innerHTML = "She's taller than our largest size (" + fmt(max) + ' cm / ' + fmt(max / 2.54) + ' in).' + help; return; }
      var m = [];
      ranges.forEach(function (r, i) { if (h >= r[0] && h <= r[1]) m.push(i); });
      hit = m[m.length - 1];
      var data = unit === 'in' && hasIn ? inch : cm;
      var age = cm.rows[hit][0];
      var note = m.length > 1
        ? "She's right between two sizes. We suggest the larger one, so she has room to move and twirl."
        : 'This size fits girls ' + esc(data.rows[hit][hIdx]) + ' ' + unit + ' tall.';
      res.innerHTML = 'Her size: <strong><em>' + esc(age) + '</em></strong><br>' + note +
        (findVariant(age) ? '<br><button type="button" class="cd2-choose" data-age="' + esc(age) + '">Choose ' + esc(age) + '</button>' : '');
    }

    function refresh() { find(); draw(); }

    root.addEventListener('click', function (e) {
      var u = e.target.closest && e.target.closest('.cd2-units button');
      if (u) {
        unit = u.getAttribute('data-u');
        root.querySelectorAll('.cd2-units button').forEach(function (x) {
          var on = x === u; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        refresh();
        return;
      }
      var b = e.target.closest && e.target.closest('.cd2-choose');
      if (b) {
        var hitV = findVariant(b.getAttribute('data-age'));
        if (!hitV) return;
        if (hitV.kind === 'radio') {
          hitV.el.click();
        } else {
          var sel = hitV.el.parentNode;
          sel.value = hitV.el.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
      }
    });
    if (input) input.addEventListener('input', refresh);
    refresh();
  }

  function scan(root) {
    [].forEach.call((root || document).querySelectorAll('.cdsg:not([data-cd2])'), enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
